export default {
  methods: {
    setTitle() {
      const title = this.title ? `${this.title} | RayPRO` : `RayPRO`

      window.document.title = title
    }
  },

  created() {
    this.setTitle()
  },

  watch: {
    title() {
      this.setTitle()
    },

    '$route': function() {
      this.setTitle()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/page.js